export type RelatedLink = {
  title: string;
  slug: string;
};

function extractSlugFromPath(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) return '';

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const pathname = new URL(trimmed).pathname;
      return pathname.replace(/^\/statistics\//, '').replace(/^\//, '').trim();
    } catch {
      return trimmed;
    }
  }

  return trimmed.replace(/^\/statistics\//, '').replace(/^\//, '').trim();
}

/** Normalize legacy/imported related link shapes to { title, slug }. */
export function normalizeRelatedLink(link: unknown): RelatedLink | null {
  if (!link) return null;

  if (typeof link === 'string') {
    const slug = extractSlugFromPath(link);
    return slug ? { title: '', slug } : null;
  }

  if (typeof link === 'object') {
    const obj = link as Record<string, unknown>;
    const title = typeof obj.title === 'string' ? obj.title : '';
    const rawSlug =
      (typeof obj.slug === 'string' ? obj.slug : '') ||
      (typeof obj.url === 'string' ? obj.url : '');
    const slug = extractSlugFromPath(rawSlug);
    if (!slug) return null;
    return { title, slug };
  }

  return null;
}

export function normalizeRelatedLinks(links: unknown): RelatedLink[] {
  if (!Array.isArray(links)) return [];
  return links
    .map(normalizeRelatedLink)
    .filter((link): link is RelatedLink => link !== null);
}

export function formatRelatedLinksForDisplay(links: unknown): string {
  const normalized = normalizeRelatedLinks(links);
  if (!normalized.length) return 'Ninguno';
  return normalized.map((link) => link.title || link.slug).join(', ');
}
